import React from 'react';
import styles from './LabeledToggleButton.module.scss';
import { ToggleButton } from '..';
import { LabeledToggleButtonProps } from './types';

const LabeledToggleButton = (props: LabeledToggleButtonProps) => {
  const {
    label, switchedOn, onClick, size, className = '', style = {}
  } = props;

  const classes = [styles.container, className].join('');

  return (
    <div className={classes} onClick={onClick} style={style}>
      <ToggleButton
        switchedOn={switchedOn}
        onClick={onClick}
        size={size}
      />
      {label}
    </div>
  );
};

export default LabeledToggleButton;
